
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link, useLocation } from 'react-router-dom';
import { Dashboard } from '@mui/icons-material';
import styled from '@emotion/styled';
import SelectBox from '../../components/GenericClick/SelectBox';
import { useEffect, useState } from 'react';
import { Navigation } from '../../../../Navigation';

import { UseRoleContext } from '../../../../utils/RoleContext';
const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: 'inherit',
  ":hover": {
    background: '#acb2d5',
  },

}))
type PathToActiveBox = {
  [key: string]: number;
};

export const OperateurMenu = () => {






  const [activeBox, setActiveBox] = useState<number>(0);
  const location = useLocation();


  useEffect(() => {
    const path = location.pathname.split('/')[1];
    const pathToActiveBox: PathToActiveBox = {
      '': 1,
      'bestsileo': 2,
      'suiviMensuel': 3,
      'questionnaire': 4,
      'bokimbola': 5,
      'bokimpanjifa': 6,
      'tricycle': 7,
      'fanoratana': 8,



    };
    setActiveBox(pathToActiveBox[path]);
  }, [location.pathname]);

  //bare de navigation : 
  const ajouterNavigation = (nav: Navigation) => {

  }




  const role = UseRoleContext()

  return (
    <>
      <StyledLink to={"/"}>
        <SelectBox
          isActive={activeBox === 1}
          onClick={() => { setActiveBox(1); ajouterNavigation({ title: "Collaborateur", link: "/", isActive: true }); }}
        >
          <ListItemButton>
            <ListItemIcon>
              <Dashboard sx={{ color: 'white' }} />
            </ListItemIcon>
            <ListItemText primary="Acceuil" />
          </ListItemButton>
        </SelectBox>
      </StyledLink>

      <StyledLink to={"/betsileo"}>
        <SelectBox
          isActive={activeBox === 2}
          onClick={() => { setActiveBox(2); ajouterNavigation({ title: "betsileo", link: "/betsileo", isActive: true }); }}
        >
          <ListItemButton>
            <ListItemIcon>
              <Dashboard sx={{ color: 'white' }} />
            </ListItemIcon>
            <ListItemText primary="Fakana fako betsileo" />
          </ListItemButton>
        </SelectBox>
      </StyledLink>

      <StyledLink to={"/suiviMensuel"}>
        <SelectBox
          isActive={activeBox === 3}
          onClick={() => { setActiveBox(1); ajouterNavigation({ title: "Suivi Mensuel", link: "/suiviMensuel", isActive: true }); }}
        >
          <ListItemButton>
            <ListItemIcon>
              <Dashboard sx={{ color: 'white' }} />
            </ListItemIcon>
            <ListItemText primary="Suivi Mensuel" />
          </ListItemButton>
        </SelectBox>
      </StyledLink>

      <StyledLink to={"/questionnaire"}>
        <SelectBox
          isActive={activeBox === 4}
          onClick={() => { setActiveBox(1); ajouterNavigation({ title: "Questionnaire", link: "/questionnaire", isActive: true }); }}
        >
          <ListItemButton>
            <ListItemIcon>
              <Dashboard sx={{ color: 'white' }} />
            </ListItemIcon>
            <ListItemText primary="Questionnaire" />
          </ListItemButton>
        </SelectBox>
      </StyledLink>

      <StyledLink to={"/bokimbola"}>
        <SelectBox
          isActive={activeBox === 5}
          onClick={() => { setActiveBox(1); ajouterNavigation({ title: "Bokim-bola", link: "/bokimbola", isActive: true }); }}
        >
          <ListItemButton>
            <ListItemIcon>
              <Dashboard sx={{ color: 'white' }} />
            </ListItemIcon>
            <ListItemText primary="Bokim-bola" />
          </ListItemButton>
        </SelectBox>
      </StyledLink>

      <StyledLink to={"/bokimpanjifa"}>
        <SelectBox
          isActive={activeBox === 6}
          onClick={() => { setActiveBox(1); ajouterNavigation({ title: "Bokim-panjifa", link: "/bokimpanjifa", isActive: true }); }}
        >
          <ListItemButton>
            <ListItemIcon>
              <Dashboard sx={{ color: 'white' }} />
            </ListItemIcon>
            <ListItemText primary="Bokim-panjifa" />
          </ListItemButton>
        </SelectBox>
      </StyledLink>

      <StyledLink to={"/tricycle"}>
        <SelectBox
          isActive={activeBox === 7}
          onClick={() => { setActiveBox(1); ajouterNavigation({ title: "Tricycle", link: "/tricycle", isActive: true }); }}
        >
          <ListItemButton>
            <ListItemIcon>
              <Dashboard sx={{ color: 'white' }} />
            </ListItemIcon>
            <ListItemText primary="Tricycle" />
          </ListItemButton>
        </SelectBox>
      </StyledLink>

      <StyledLink to={"/fanoratana"}>
        <SelectBox
          isActive={activeBox === 8}
          onClick={() => { setActiveBox(1); ajouterNavigation({ title: "Fanoratana", link: "/fanoratana", isActive: true }); }}
        >
          <ListItemButton>
            <ListItemIcon>
              <Dashboard sx={{ color: 'white' }} />
            </ListItemIcon>
            <ListItemText primary="Fanoratana" />
          </ListItemButton>
        </SelectBox>
      </StyledLink>
    </>
  );
}
